module.exports = __webpack_public_path__ + "static/media/PersonalLogo_NoBG.87902d38.png";